import React from 'react';

/**
 * Honest announcement bar: no fake timers or counters, and NEVER a price (Tomás rule).
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="306bpqvmn8dxq">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2vdim6b2wvbn8">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2mednn4rcnib2">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-59" data-mp="2mcanvt0eaat5" />
        </span>
        <span className="text-stone-50/80" data-id="element-60" data-mp="2hdzh5r5ecgf5">
          <span className="font-semibold text-stone-50" data-id="element-61" data-mp="2cfo5rbzgdxut">Једнократна уплата</span>
          <span data-id="element-62" data-mp="28em4yqpw1dqq"> · Одмах на мејл · 7 дана гаранције</span>
        </span>
      </div>
    </div>;
}